import styles from "./sharedDataForm.module.scss";
import Select from "react-select";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import Button from "../../components/button/Button";
import {
  getLookupOptionsData,
  handleSaveForm,
  sdModalInfo,
  setSdModal,
  formInputData,
  getProductInfo,
  setFormInputValues,
  existingInputData,
  availableSdInputStateList,
  sdStates,
  setClonedFrom,
  getClonedFrom,
  sendSdpEmailNotification,
  getRecipeData,
  saveAsDraftActionItem,
  resetFormInputValues,
} from "../sharedData/sharedDataSlice";
import SharedDataPopup from "../../components/popUp/SharedDataPopup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validateForm,validateSingleField  } from "../../utilities/helperMethods";
import CloneModal from "../../components/popUp/CloneModal";
// import { setToast } from "../../app/appSlice";
import Popup from "../../components/popUp/Popup";
import constants from "../../utilities/constants";
import sharedDataApi from "../../api/sharedDataApi";
import RenderComments from "../reviewSharedData/RenderComments";
import { setLoading, setToast, selectUser } from "../../app/appSlice";
import { productApi } from "../../api/productApi";
import { executeCoolCloudOperations } from "../../services/CoolCloudService";
import { pushToCoolCloudProduction, getProductInfoById } from "../sharedData/sharedDataSlice";
import { executeProductionOperations } from "../../services/moveToProductionService";
import { FaInfoCircle } from "react-icons/fa";

export const fieldTypeOptions = Object.freeze({
  text: "text",
  dropdown: "dropdown",
});

const SharedDataForm = ({ fields, action, currentSdState, setSdState }) => {
  const inputFields = fields.filter((item) => item.type === "input");
  const recipeData = useSelector(getRecipeData);
  const [users, setUsers] = useState([]);
  const dispatch = useDispatch();
  const store = useStore();
  const productInfo = useSelector(getProductInfo);
  const formInputs = useSelector(formInputData);
  const existingInputs = useSelector(existingInputData);
  const availableSdInputStates = useSelector(availableSdInputStateList);
  const currentUser = useSelector(selectUser);

  const [errors, setErrors] = useState({});
  const [showCloneModal, setShowCloneModal] = useState(false);
  const [testingConfirmed, setTestingConfirmed] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [popupAction, setPopupAction] = useState(null);
  const [currentRadioOption, setCurrentRadioOption] = useState(currentSdState);
  const [selectedRadioOption, setSelectedRadioOption] = useState("");
  const [comments, setComments] = useState([]);
  const [actionItem, setActionItem] = useState({});
  const [cloneFromProduct, setClonedFromProduct] = useState({});
  const [cloneFormData, setCloneFormData] = useState({});
  const [updateActionItemMode, setUpdateActionItemMode] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);

  const [searchParam, _] = useSearchParams();

  const lookupOptions = useSelector(getLookupOptionsData);
  const sharedDataModal = useSelector(sdModalInfo);
  const navigate = useNavigate();
  const cloneFromStoreData = useSelector(getClonedFrom);

  const [replyText, setReplyText] = useState("");
  const [isTextBoxVisible, setIsTextBoxVisible] = useState(false);
  const [replyingTo, setReplyingTo] = useState({});

  const [isPushed, setIsPushed] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);

  const [hexError, setHexError] = useState({});


  const jsonByteMatchCountRef = useRef(0);  
  useEffect(() => {
    // Reset all form state when this form instance unmounts (navigating away)
    return () => {
      dispatch(resetFormInputValues());
    };
  }, []);

useEffect(() => {
  const jsonByteMatchFields = recipeData && Array.isArray(recipeData) ?
    recipeData.filter((item) => item.type === "JsonByteMatch" && item.fieldName && item.fieldName.trim() !== "") : [];
  
  jsonByteMatchCountRef.current = jsonByteMatchFields.length;
}, [recipeData]);


  const isPreApproved =
    (!actionItem?.id || actionItem?.State !== "Draft") &&
    (productInfo?.State === sdStates.staging ||
      productInfo?.State === sdStates.production);

  useEffect(() => {
    const initiatePage = async () => {
      await fetchCloneFromProduct();
    };

    initiatePage();
  }, [actionItem, cloneFromStoreData]);

  const fetchCloneFromProduct = async () => {
    if (
      (actionItem && actionItem.CloneFromProductId) ||
      cloneFromStoreData.id
    ) {
      const payload = {
        or: [
          {
            id: {
              eq: `${actionItem?.CloneFromProductId || cloneFromStoreData.id}`,
            },
          },
        ],
      };

      const updatedPayload = {
        filter: payload,
        initLoad: true,
        limit: 10,
      };
      try {
        const products = await productApi.searchProducts(updatedPayload);
        setClonedFromProduct(products.items[0] || {});
      } catch (error) {
        console.error("Failed to fetch clone from product:", error);
      }
    }
  };
  //----------------

  const cloneFromExisting = async (
    modelNumber,
    stage,
    version,
    clonedFromId
  ) => {
    if (modelNumber && stage) {
      const inputValues = await getUserInputsForCloning(
        modelNumber,
        version,
        stage
      );
      // onSuccess(JSON.parse(inputValues.Input));
      dispatch(setClonedFrom({ id: clonedFromId }));
      onCloneSuccess(JSON.parse(inputValues.Input));
    }
  };

  useEffect(() => {
    const actionId = searchParam.get("id");
    const clonedFromId = searchParam.get("cloneId");
    const modelNumber = searchParam.get("model");
    const stage = searchParam.get("stage");
    const version = searchParam.get("version");

    const initForm = async () => {
      try {
        // Step 1: Try to fetch the action item (draft) FIRST
        if (actionId) {
          const fetchedActionItem = await sharedDataApi.getActionItemById(actionId);

          if (fetchedActionItem) {
            // Block access if the action item is IN_REVIEW and created by a different user
            if (
              fetchedActionItem.Status === "IN_REVIEW" &&
              fetchedActionItem.CreatedByEmail?.toLowerCase() !== store.getState().app.user?.email?.toLowerCase()
            ) {
              showToastMessage(
                `This product has already been submitted for review by ${fetchedActionItem.CreatedByEmail}.`
              );
              navigate("/products");
              return;
            }

            setActionItem(fetchedActionItem);
            setUpdateActionItemMode(true);

            // If a draft with saved Input exists, apply it and STOP — do not apply clone values
            if (
              (!clonedFromId && fetchedActionItem.Input) ||
              (clonedFromId && productInfo?.State === sdStates.draft && fetchedActionItem.Input)
            ) {
              applyDefaultValuesOnForm(JSON.parse(fetchedActionItem.Input));
              return; // draft takes priority, skip clone fetch entirely
            }
          } else {
            console.warn("No action item found with the provided actionId.");
          }
        }

        // Step 2: Only apply clone values if no draft was found/applied above
        if (modelNumber && stage && clonedFromId) {
          const inputValues = await getUserInputsForCloning(modelNumber, version, stage, clonedFromId);
          if (inputValues) {
            onCloneSuccess(JSON.parse(inputValues.Input));
            dispatch(setClonedFrom({ id: clonedFromId }));
          }
        }

        // Step 3: Check updateActionItemMode for staging/production with no actionId
        if (
          !actionId &&
          (productInfo?.State === sdStates.staging || productInfo?.State === sdStates.production)
        ) {
          const response = await sharedDataApi.listActionItems({
            filter: {
              ProductId: { eq: productInfo?.id },
              State: { eq: productInfo?.State },
            },
          });
          const items = response?.items || [];
          if (items.length === 0) {
            setUpdateActionItemMode(true);
          }
        }
      } catch (error) {
        console.error("Failed to initialise form:", error);
      }
    };

    initForm();
  }, []);

   const getUserInputsForCloning = async (modelNumber, versionNumber, state, cloneFromProductId = null) => {
    try {
      const response = await sharedDataApi.fetchModelNumberByState({
        ModelNumber: modelNumber,
        State: { eq: state },
        filter: { Version: { eq: versionNumber } },
        limit: 10000,
      });

    // Check if we have any results
      if (!response.items || response.items.length === 0) {
        console.warn("No recipe inputs found for the given criteria");
        return null;
      }

      // If we have cloneFromProductId, find the exact match by ID
      if (cloneFromProductId && response.items.length > 0) {
        const exactMatch = response.items.find(item => item.id === cloneFromProductId);
        if (exactMatch) {
          console.log("Found exact match by ID:", exactMatch);
          return exactMatch;
        }
      }

      const inputValues = response.items[0];
      console.log("No exact match found, returning first item:", inputValues);
      return inputValues;
    } catch (error) {
      console.error("Error fetching inputs for cloning:", error);
      return null;
    }
  };

  const isAdmin = (user) => {
    return user.roles.includes(constants.userRoles.admin);
  };

  const onCancel = () => {
    // Reset reply text and hide reply form in the parent component
    setReplyText("");
    setIsTextBoxVisible(false);
    setReplyingTo({});
    console.log("onCancel in Parent called11111");
  };

  const onReplySubmit = async (replyPayload) => {
    try {
      dispatch(setLoading({ isLoading: true }));
      // Call API to create the comment on the server
      await sharedDataApi.createComment({
        input: { ...replyPayload, date: new Date(replyPayload.date) },
      });

      // Update local comments state with the new reply
      setComments((prevComments) => [...prevComments, replyPayload]);
      console.log("onCancel in Parent called");
      onCancel();
      // Reset and hide the reply form by calling handleCancel
    } catch (error) {
      console.error("Error submitting reply:", error);
    } finally {
      dispatch(setLoading({ isLoading: false }));
    }
  };

  const onDeleteComment = async (comment) => {
    dispatch(setLoading({ isLoading: true }));
    await sharedDataApi.deleteComment({
      input: {
        commentId: comment.commentId,
        date: new Date(comment.date),
      },
    });

    setComments(comments.filter((c) => c.commentId !== comment.commentId));
    dispatch(setLoading({ isLoading: false }));
  };

  useEffect(() => {
    const actionId = searchParam.get("actionId");
    if (actionId) {
      // console.log("argument to form " + fields);
      const fetchcomments = async () => {
        let allComments = [];
        let nextToken = null;

        do {
          const commentList = await sharedDataApi.listComments({
            filter: { actionId: { eq: actionId } },
            nextToken: nextToken,
          });

          allComments = [...allComments, ...(commentList.items || [])];
          nextToken = commentList.nextToken;
        } while (nextToken);

        setComments(allComments);
      };
      fetchcomments();
    }
  }, []);

  useEffect(() => {
    applyDefaultValuesOnForm({});
  }, []);

  useEffect(() => {
    if (cloneFromProduct.id) {
      console.log(cloneFromProduct.id);
      const fetchRecipeInputFields = async () => {
        const currSdState = cloneFromProduct.State;
        let params = {};
        // setLoading(true);
        try {
          params = {
            ModelNumber: cloneFromProduct.ModelNumber,
            State: { eq: currSdState },
            limit: 10000,
          };
          if (
            currSdState === sdStates.staging ||
            currSdState === sdStates.production
          ) {
            const versionField = `${currSdState}Version`;
            params["filter"] = {
              Version: { eq: cloneFromProduct[versionField] },
            };
          }
          const userInputs = await sharedDataApi.fetchModelNumberByState(
            params
          );
          setCloneFormData(userInputs.items);
          console.log(userInputs);
          // setLoading(false);
        } catch (error) {
          // setLoading(false);
        }
      };

      fetchRecipeInputFields();
    }
  }, [cloneFromProduct]);

  const getAllSdUserInput = async () => {
    const params = {
      filter: {
        or: [
          {
            State: {
              eq: sdStates.production,
            },
            ModelNumber: {
              eq: actionItem.ModelNumber,
            },
          },
          {
            State: {
              eq: sdStates.staging,
            },
            ModelNumber: {
              eq: actionItem.ModelNumber,
            },
          },
          {
            State: {
              eq: sdStates.draft,
            },
            ModelNumber: {
              eq: actionItem.ModelNumber,
            },
          },
        ],
      },
      limit: 1000,
    };

    let allItems = [];
    let nextToken = null;

    try {
      do {
        const response = await sharedDataApi.fetchUserInputs({
          ...params,
          nextToken,
        });

        const items = response?.items || response?.data?.listSdpRecipeInputs?.items || [];
        allItems = [...allItems, ...items];
        nextToken = response?.nextToken || response?.data?.listSdpRecipeInputs?.nextToken;
      } while (nextToken);

      return allItems;
    } catch (error) {
      console.error("Error fetching paginated SdUserInputs:", error);
      return [];
    }
  };

  useEffect(() => {
    const getUserDetails = async () => {
      const sdpUserList = await sharedDataApi.listSdpUsers();
      setUsers(
        sdpUserList.items
          .filter((item) => item.Role.indexOf("admin") !== -1)
          .map((item) => ({
            label: item.Name,
            value: item.Email,
          }))
      );
    };
    getUserDetails();
  }, []);

  // useEffect(() => {
  //   const getUserDetails = async () => {
  //     const sdpUserList = await sharedDataApi.listSdpUsers();
  //     const adminUsers = sdpUserList.items
  //       .filter((item) => item.Role.indexOf("admin") !== -1)
  //       .map((item) => ({
  //         label: item.Name,
  //         value: item.Email,
  //       }));
      
  //     // Filter out the current user from the reviewer options
  //     const filteredUsers = adminUsers.filter(user => 
  //       user.value.toLowerCase() !== currentUser.email?.toLowerCase()
  //     );
      
  //     setUsers(filteredUsers);
  //   };
  //   getUserDetails();
  // }, [currentUser.email]);

  const validateStagingForm = () => {
    const hasCloneFromId = !!(cloneFromProduct.id || cloneFromStoreData.id);
    const jsonByteMatchCount = hasCloneFromId
      ? Object.keys(formInputs).filter(key => recipeData?.find(f => f.fieldName === key)?.type === "JsonByteMatch").length
      : 0;
    return validateForm(inputFields, formInputs, sdStates.staging, jsonByteMatchCount, hasCloneFromId);
  };

  const updateActionItemData = async () => {
    const validationResponse = validateStagingForm();
    if (!validationResponse.stateValidation) {
      showToastMessage(
        `All Field values must be entered before saving to ${sdStates.staging}.`
      );
      return;
    }
    if (Object.keys(validationResponse.fieldValidation).length > 0) {
      setErrors(validationResponse.fieldValidation);
      showToastMessage(
        `Check following fields and fix the error: ${Object.keys(
          validationResponse.fieldValidation
        ).toString()}.`
      );
      return;
    }
    dispatch(setLoading({ isLoading: true }));

    const userInputs = await getAllSdUserInput();
    const recipeId = userInputs[0]?.id;

    if (
      actionItem?.State === userInputs[0]?.State &&
      (actionItem?.State === sdStates.staging || actionItem?.State === sdStates.production)
    ) {
      // This code will run if the state matches
      const payload = {
        input: {
          id: actionItem.id,
          Input: JSON.stringify(formInputValues),
          State: sdStates.staging,
        },
      };

      const params = {
        input: {
          id: recipeId,
          ModelNumber: actionItem.ModelNumber,
          Input: JSON.stringify(formInputValues),
          State: sdStates.staging,
        },
      };
      await sharedDataApi.updateSdUserInputs(params);

      const productPayload = {
        input: {
          id: actionItem.ProductId,
          State: sdStates.staging,
          SdAvailable: true,
          StagingVersion: 0,
          ModelNumber: actionItem.ModelNumber,
          AMSAck: false,
        },
      };

      await productApi.updateProductData(productPayload);
      await sharedDataApi.updateActionItems(payload);
    } else {
      // Default case if the state does not match
      const payload = {
        input: {
          id: actionItem.id,
          Input: JSON.stringify(formInputValues),
        },
      };

      await sharedDataApi.updateActionItems(payload);
    }

    // navigate("/dashboard");
    if (actionItem?.State === sdStates.staging || actionItem?.State === sdStates.production) {
      navigate("/products");
    } else {
      navigate("/dashboard?tab=outgoing");
    }
    dispatch(setLoading({ isLoading: false }));
};

const sendUpdateEmailNotification = async (previousInputs = null) => {
  // Use passed previousInputs, or fetch if not provided
  let prevInputs = previousInputs;
  if (!prevInputs) {
    const userInputsArr = await getAllSdUserInput();
    prevInputs = userInputsArr[0]?.Input ? JSON.parse(userInputsArr[0].Input) : {};
  }
  const currentInputs = formInputs;
  const changedFields = Object.keys(currentInputs).filter(
    key =>{
      // Skip JsonByteMatch and non-input fields
      const fieldDef = recipeData?.find(f => f.fieldName === key);
      if (fieldDef && fieldDef.type !== "input") return false;
      
      // Skip Reviewer field
      if (key === "Reviewer") return false;
      
      return (
        (prevInputs[key] !== undefined && currentInputs[key] !== prevInputs[key]) ||
        (prevInputs[key] === undefined && currentInputs[key] !== undefined && currentInputs[key] !== "")
      );
    }
  ).map(key => ({
    name: key,
    previousInput: prevInputs[key] !== undefined ? prevInputs[key] : "-",
    newInput: currentInputs[key] !== undefined ? currentInputs[key] : "-"
  }));

  // Get performer's email (current user performing the action)
  const currentUserEmail = (currentUser?.email || "").toLowerCase();

  // Get creator email and name
  const creatorEmail = (actionItem?.CreatedByEmail || "").toLowerCase();
  let userNameToUse = creatorEmail;
  if (actionItem?.CreatedByEmail) {
    try {
      const userRes = await sharedDataApi.listSdpUsers({
        filter: { Email: { eq: actionItem.CreatedByEmail } }
      });
      const user = (userRes?.items || []).find(
        u => u.Email?.toLowerCase() === actionItem.CreatedByEmail.toLowerCase()
      );
      if (user && user.Name) userNameToUse = user.Name;
    } catch {
      userNameToUse = actionItem.CreatedByEmail;
    }
  }

  // Use ReviewerEmails array if available, otherwise fallback to ReviewerEmail
  const reviewerEmails = (actionItem?.ReviewerEmails && Array.isArray(actionItem.ReviewerEmails) && actionItem.ReviewerEmails.length > 0)
    ? actionItem.ReviewerEmails.map(e => e.toLowerCase())
    : [(actionItem?.ReviewerEmail || "").toLowerCase()].filter(Boolean);

  // To: Creator
  // CC: All reviewers (including performer for visibility) + Creator
  // From: Current user (performer)
  const toEmails = [creatorEmail].filter(Boolean);
  let ccEmails = [...reviewerEmails];

  // Ensure performer is in CC for visibility
  if (!ccEmails.includes(currentUserEmail)) {
    ccEmails.push(currentUserEmail);
  }

  // Remove creator from CC if they're already in To
  ccEmails = ccEmails.filter(email => !toEmails.includes(email));


  // Remove duplicates and empty values
  ccEmails = [...new Set(ccEmails.filter(Boolean))];

  const emailParams = {
    emails: toEmails,
    templateId: "sdp_email_notification",
    templateData: JSON.stringify({
      emailSubject: "CoolCloud and AMS data successfully pushed",
      fromEmail: currentUserEmail,
      cc: ccEmails,
      userName: userNameToUse,
      date: new Date().toLocaleDateString(),
      modelNumber: actionItem?.ModelNumber || "Unknown",
      reasonForChange: `Production Update for ${actionItem.ModelNumber}`,
      userInputs: changedFields,
      changesDoneTo: "The production product has been updated successfully in CoolCloud App and AMS environment."
    })
  };
  console.log("[NOTIFY] Sending email notification with params:", emailParams);
  dispatch(sendSdpEmailNotification(emailParams));
};

  const selectDefaultReviewer = () =>
    users.filter((user) => user.value === actionItem.ReviewerEmail)[0];

  const valuesArray = Object.keys(inputFields).reduce(
    (acc, curr, index) => (
      index % 2 === 0 ? acc.push([curr]) : acc[acc.length - 1].push(curr), acc
    ),
    []
  );

  const getOptions = (field) => {
    let optionName = field.arguments;
    optionName = optionName.replace(/'/g, '"');
    optionName = JSON.parse(optionName);
    return lookupOptions[optionName[0]];
  };

  const getOptionLabel = (field) => {
    const options = getOptions(field);
    const res = options.filter(({ label }) => {
      const inputField = formInputs[field.fieldName];
      return label === inputField;
    });
    return res;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const field = inputFields.find((f) => f.fieldName === name);
    
    let processedValue = value;

    // Handle different data types for numeric inputs
    if (field?.dataType === "number" && value.includes('.')) {
      // For number fields (integer behavior), remove decimal points
      processedValue = value.split('.')[0];
    } else if (field?.dataType === "float" && value.includes('.')) {
      // For float fields, limit to 6 decimal places
      const parts = value.split('.');
      if (parts[1] && parts[1].length > 6) {
        processedValue = parts[0] + '.' + parts[1].substring(0, 6);
      }
    }
    
    dispatch(setFormInputValues({ ...formInputs, [name]: processedValue }));

    // Validate the single field
    const errorMessage = validateSingleField(field, processedValue);
    setErrors((prevState) => ({
      ...prevState,
      [name]: errorMessage,
    }));
    if (updateActionItemMode) {
      const originalInputs = actionItem?.Input ? JSON.parse(actionItem.Input) : {};
      const updatedInputs = { ...formInputs, [name]: processedValue };
      const hasChanges = Object.keys(updatedInputs).some(
        (k) => String(updatedInputs[k]) !== String(originalInputs[k] ?? "")
      );
      setIsFormChanged(hasChanges);
      if (hasChanges) {
        setIsPushed(false);
      }

    }
  };

  const handleCheckbox = () => {
    setTestingConfirmed(!testingConfirmed);
  };

  const handleSelectChange = (name, selectedOption) => {
    const { label, value } = selectedOption;
    if (name === "Reviewer") {
      dispatch(setFormInputValues({ ...formInputs, [name]: value }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    } else {
      dispatch(setFormInputValues({ ...formInputs, [name]: label }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    }
    if (updateActionItemMode) {
      const originalInputs = actionItem?.Input ? JSON.parse(actionItem.Input) : {};
      const newValue = name === "Reviewer" ? value : label;
      const updatedInputs = { ...formInputs, [name]: newValue };
      const hasChanges = Object.keys(updatedInputs).some(
        (k) => String(updatedInputs[k]) !== String(originalInputs[k] ?? "")
      );
      setIsFormChanged(hasChanges);
      if (hasChanges) {
        setIsPushed(false);
      }

    }
  };

  const showToastMessage = (toastMessage) => {
    dispatch(
      setToast({
        isOpen: true,
        message: toastMessage,
        onDismiss: () => dispatch(setToast({ isOpen: false })),
      })
    );
  };
const cleanDisplayValue = (value) => {
    if (typeof value === 'string') {
      return value.replace(/\u0000/g, '');
    }
    return value;
  };

  const checkForInputChanges = (saveToState) => {
    let changes = {
      detected: true,
      message: "",
    };
    let previousInputValues = {};
    if (currentSdState === saveToState) {
      previousInputValues = { ...existingInputs };
    } else {
      const previousSdInput = availableSdInputStates.filter((item) => {
        const versionField = `${saveToState}Version`;
        return (
          item.State === saveToState &&
          item.Version === productInfo[versionField]
        );
      });
      if (previousSdInput.length > 0) {
        const inputValues = JSON.parse(previousSdInput[0].Input);
        previousInputValues = inputValues;
      }
    }
    if (
      (Object.keys(previousInputValues).length === 0 ||
        Object.keys(previousInputValues).length > 0) &&
      Object.keys(formInputs).length === 0
    ) {
      changes["detected"] = false;
      changes["message"] = "No changes detected.";
    } else if (
      Object.keys(previousInputValues).length > 0 &&
      Object.keys(formInputs).length > 0
    ) {
      let inputFields = [];
      for (const [key, value] of Object.entries(formInputs)) {
        if (previousInputValues[key] !== value) {
          inputFields.push(key);
        } else if (value && !previousInputValues[key]) {
          inputFields.push(key);
        }
      }
      if (inputFields.length === 0) {
        changes["detected"] = false;
        changes["message"] = "No changes detected.";
      }
    } else if (
      Object.keys(previousInputValues).length === 0 &&
      Object.keys(formInputs).length > 0
    ) {
      let inputFields = [];
      for (const [key, value] of Object.entries(formInputs)) {
        if (value) {
          inputFields.push(key);
        }
      }
      if (inputFields.length === 0) {
        changes["detected"] = false;
        changes["message"] = "No changes detected.";
      }
    }
    return changes;
  };

  const saveToState = async (state, action) => {
    if (state === sdStates.production && !testingConfirmed) {
      // showToastMessage(
      //   `Confirm that the staging data is tested with the actual devices and is ready to push to production.`
      // );
    }
    try {
      const existingActionItem = await sharedDataApi.getActionItemById(productInfo?.id);

      if (existingActionItem) {
        const currentUserEmail = currentUser?.email?.toLowerCase();

        // Check if there's an IN_REVIEW action item created by a different user
        if (
          existingActionItem.Status === "IN_REVIEW" &&
          existingActionItem.CreatedByEmail?.toLowerCase() !== currentUserEmail
        ) {
          showToastMessage(
            `This product has already been submitted for review by ${existingActionItem.CreatedByEmail}.`
          );
          return;
        }
      }
    } catch (error) {
      console.error("Error checking existing submissions:", error);
    }

    const changes = checkForInputChanges(state);
    if (!changes.detected) {
      showToastMessage(changes.message);
    } else {
          const hasCloneFromId = !!(cloneFromProduct.id || cloneFromStoreData.id);
      let jsonByteMatchInFormInputs = 0;
      if (hasCloneFromId) {
        jsonByteMatchInFormInputs = Object.keys(formInputs).filter(
          key => {
            const fieldDef = recipeData?.find(f => f.fieldName === key);
            return fieldDef && fieldDef.type === "JsonByteMatch";
          }
        ).length;
      }
      const validationResponse = validateForm(inputFields, formInputs, state, jsonByteMatchInFormInputs, hasCloneFromId);
      if (!validationResponse.stateValidation) {
        showToastMessage(
          `All Field values must be entered before saving to ${state}.`
        );
      }
      if (Object.keys(validationResponse.fieldValidation).length > 0) {
        setErrors(validationResponse.fieldValidation);
        showToastMessage(
          `Check following fields and fix the error: ${Object.keys(
            validationResponse.fieldValidation
          ).toString()}.`
        );
      }
      if (
        validationResponse.stateValidation &&
        Object.keys(validationResponse.fieldValidation).length === 0
      ) {
        dispatch(
          handleSaveForm({
            state: state,
          })
        );
      }
    }
  };

  const dismissModal = () => {
    dispatch(
      setSdModal({
        isOpen: false,
        type: null,
        revisionNumber: [],
      })
    );
  };

  const handleRadioInputChange = (e) => {
    const { value } = e.target;
    setSelectedRadioOption(value);
    const inputChangesDetected = checkForInputChanges(currentSdState);
    if (inputChangesDetected.detected) {
      e.preventDefault();
      setCurrentRadioOption(currentRadioOption);
      setShowPopup(true);
    } else {
      setTestingConfirmed(false);
      setSdState(value);
      setCurrentRadioOption(value);
    }
  };

  const checkIfFormIsFilled = () => {
    if (isPreApproved) {
      // Only check input fields (not reviewer)
      const filteredFormKeys = Object.keys(formInputs).filter((key) =>
        inputFields.some((f) => f.fieldName === key)
      );
      return (
        filteredFormKeys.length === inputFields.length &&
        filteredFormKeys.every(
          (key) => formInputs[key] || formInputs[key] === 0
        )
      );
    } else {
      const hasCloneFromId = !!(cloneFromProduct.id || cloneFromStoreData.id);
      let jsonByteMatchInFormInputs = 0;
      if (hasCloneFromId) {
        // Count how many JsonByteMatch fields are actually present in formInputs
        jsonByteMatchInFormInputs = Object.keys(formInputs).filter(
          key => {
            // Find the field definition in the recipeData
            const fieldDef = recipeData?.find(f => f.fieldName === key);
            return fieldDef && fieldDef.type === "JsonByteMatch";
          }
        ).length;
      }

      // Legacy logic
      const inputFieldLength = hasCloneFromId
      ? Object.keys(inputFields).length + jsonByteMatchInFormInputs === Object.keys(formInputs).length - 1
      : Object.keys(inputFields).length === Object.keys(formInputs).length - 1;

      // Reviewer check: must exist and not be empty
      const reviewer = formInputs["Reviewer"];
      const reviewerValid = Array.isArray(reviewer)
        ? reviewer.length > 0
        : !!reviewer;

      if (inputFieldLength && reviewerValid) {
        for (const [key] of Object.entries(formInputs)) {
          if (!formInputs[key] && formInputs[key] !== 0) {
            if (key !== "Reviewer") {
              return false;
            }
            // If Reviewer, already checked above
          }
        }
      } else {
        return false;
      }
      return inputFieldLength && reviewerValid;
    }
  };

  // const checkIfFormIsFilled = () => {
  //   const inputFieldLength =
  //     Object.keys(inputFields).length === Object.keys(formInputs).length - 1;
  //   if (inputFieldLength) {
  //     for (const [key] of Object.entries(formInputs)) {
  //       if (!formInputs[key] && formInputs[key] !== 0) {
  //         return false;
  //       }
  //     }
  //   }
  //   return inputFieldLength;
  // };

  const onCloneSuccess = (cloneValues) => {
    if (existingInputs["Unit Model"]) {
      cloneValues["Unit Model"] = existingInputs["Unit Model"];
    } else {
      delete cloneValues["Unit Model"];
    }
    delete cloneValues["Reviewer"]; // Ensure the "Reviewer" field is not cloned
    delete cloneValues["CoolCloudDBAck"]; 
    // dispatch(setFormInputValues(cloneValues));
    applyDefaultValuesOnForm(cloneValues);
    setShowCloneModal(false);
  };

  const formInputValues = useSelector(
    (state) => state.sharedData.formInputValues
  );

  useEffect(() => {
    // Ensure the necessary data exists before proceeding
    if (
      (cloneFormData && cloneFormData[0]) ||
      (actionItem && actionItem.Input)
    ) {
      const obj1 = cloneFormData[0] ? JSON.parse(cloneFormData[0].Input) : {}; // Original values from "create from existing"
      const obj2 = formInputValues; // Current form input values
      const obj3 = actionItem.Input ? JSON.parse(actionItem.Input) : {}; // Original values from "action item" editing

      // Determine whether to highlight fields
      //const shouldHighlight = cloneFromProduct.id || (actionItem && updateActionItemMode);
      const shouldHighlight = true;
        
      if (updateActionItemMode) {
        document
          .querySelectorAll(
            `.${styles.changedInputIndicator}, .${styles.changedSelectIndicator}`,
          )
          .forEach((el) =>
            el.classList.remove(
              styles.changedInputIndicator,
              styles.changedSelectIndicator,
            ),
          );
      }

      if (shouldHighlight) {
        // Use either `obj1` or `obj3` depending on the context
        // const originalValues = cloneFromProduct.id ? obj1 : obj3;
       let originalValues = {};

       if (cloneFromProduct.id && !updateActionItemMode) {
         // create from existing
         originalValues = obj1;
       } else if (updateActionItemMode) {
         // update mode
         originalValues = obj3;
       } else {
         // create new
         originalValues = {};
       }

        for (let key in originalValues) {
          const element = document.getElementById(key);
          if (element) {
            const className =
              element.tagName === "INPUT"
                ? styles.changedInputIndicator
                : styles.changedSelectIndicator;

            // Highlight if the current value differs from the original
            if (originalValues[key] !== obj2[key]) {
              element.classList.add(className);
            } else {
              element.classList.remove(className);
            }
          }
        }
      }
    }
  }, [
    cloneFormData,
    formInputValues,
    cloneFromProduct,
    actionItem,
    updateActionItemMode,
  ]);

  const getStyle = (label) => {
    const commentExists = comments.some(
      (comment) => comment.property_name === label
    );
    const inputStyle = {
      backgroundColor: commentExists ? "#FFDAB9" : "",
      borderColor: commentExists ? "#FFA500" : "",
    };
    return inputStyle;
  };

  const applyDefaultValuesOnForm = (input) => {
    // Always read the latest formInputValues from the store to avoid stale closure overwriting
    const latestFormInputs = store.getState().sharedData.formInputValues;
    Object.keys(inputFields).forEach((key) => {
      const fieldName = inputFields[key].fieldName;
      if (!latestFormInputs[fieldName]) {
        input[fieldName] = input[fieldName] || inputFields[key].defaultVal;
      }
    });

    if (Object.keys(input).length > 0) {
      dispatch(setFormInputValues({ ...latestFormInputs, ...input }));
    }
  };

  const updateApprovedProductInputs = async ({
    recipeId,
    modelNumber,
    updatedInputs,
    state = "staging",
    onSuccess,
    onError,
  }) => {
    try {
      const payload = {
        input: {
          id: recipeId,
          ModelNumber: modelNumber,
          Input: JSON.stringify(updatedInputs),
          State: state,
        },
      };

      await sharedDataApi.updateSdUserInputs(payload);
      console.log("Recipe input updated successfully.");
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Failed to update recipe input:", error);
      if (onError) onError(error);
    }
  };
  const getRecipeInputIdForApprovedProduct = async (modelNumber, state) => {
    const params = {
      filter: {
        State: { eq: state },
        ModelNumber: { eq: modelNumber },
      },
      limit: 1000,
    };

    let nextToken = null;
    let recipeId = null;

    try {
      do {
        const response = await sharedDataApi.fetchUserInputs({
          ...params,
          nextToken,
        });

        const items =
          response?.items || response?.data?.listSdpRecipeInputs?.items || [];
        if (items.length > 0) {
          recipeId = items[0].id;
          break;
        }

        nextToken =
          response?.nextToken || response?.data?.listSdpRecipeInputs?.nextToken;
      } while (nextToken && !recipeId);

      return recipeId;
    } catch (error) {
      console.error("Error fetching recipeId:", error);
      return null;
    }
  };

  const [popupConfig, setPopupConfig] = useState(null);


  const confirmPushToProduction = () => {
    const hasCloneFromId = !!(cloneFromProduct.id || cloneFromStoreData.id);

    let jsonByteMatchInFormInputs = 0;
    if (hasCloneFromId) {
      jsonByteMatchInFormInputs = Object.keys(formInputs).filter((key) => {
        const fieldDef = recipeData?.find((f) => f.fieldName === key);
        return fieldDef && fieldDef.type === "JsonByteMatch";
      }).length;
    }

    const validationResponse = validateForm(
      inputFields,
      formInputs,
      sdStates.production,
      jsonByteMatchInFormInputs,
      hasCloneFromId
    );

    if (!validationResponse.stateValidation) {
      showToastMessage(
        `All field values must be entered before modifying production.`
      );
      return;
    }

    if (Object.keys(validationResponse.fieldValidation).length > 0) {
      setErrors(validationResponse.fieldValidation);

      setPopupConfig({
        title: `Fix fields: ${Object.keys(validationResponse.fieldValidation).join(", ")}`,
        successText: "OK",
        cancelText: null,
        onSuccess: () => setPopupConfig(null),
      });

      return; 
    }


  setPopupAction("bothProduction");
  setPopupText(
    `Are you sure you want to update ${actionItem.ModelNumber} in both CoolCloud and AMS Production?`
  );
  setShowPopup(true);
};

  const handlePushToBothProduction = async () => {
    try {
      dispatch(setLoading({ isLoading: true }));
      
      // Capture previous inputs BEFORE updating the database
      const allInputsBefore = await getAllSdUserInput();
      const previousInputs = allInputsBefore[0]?.Input ? JSON.parse(allInputsBefore[0].Input) : {};
      
      const userInputs = formInputs;
    await sharedDataApi.updateActionItems({
      input: {
        id: actionItem.id,
        Input: JSON.stringify(userInputs),
        State: sdStates.production,
      },
    });

    const allInputs = await getAllSdUserInput();
    const recipeId = allInputs[0]?.id;

    if (recipeId) {
      await sharedDataApi.updateSdUserInputs({
        input: {
          id: recipeId,
          ModelNumber: actionItem.ModelNumber,
          Input: JSON.stringify(userInputs),
          State: sdStates.production,
        },
      });
    }


    const ccResult = await executeCoolCloudOperations(
      actionItem,
      productInfo,
      recipeData,
      userInputs
    );
    if (ccResult?.error) {
      console.error("CoolCloud failed:", ccResult);
      showToastMessage("Push failed.");
      return;
    }

    const latestInputPayload = [
      {
        Input: JSON.stringify(userInputs)
      }
    ];

      let amsResult = await executeProductionOperations(
        actionItem,
        recipeId,
        productInfo,
        recipeData,
        latestInputPayload
      );
      if (typeof amsResult === "string") {
        try {
          amsResult = JSON.parse(amsResult);
        } catch {}
      }

      let success = false;
      let statusCode = Number(amsResult?.statusCode);

      let body = amsResult?.body;
      if (typeof body === "string") {
        try {
          body = JSON.parse(body);
        } catch {}
      }

      if (body?.success === true || body?.success === "true") {
      success = true;
      }

      if (!(statusCode === 200 && success)) {
        showToastMessage("Push failed.");
        return;
      }
      try {
        await sendUpdateEmailNotification(previousInputs);
      } catch (emailError) {
        console.error("Production email notification failed:", emailError);
      }

      setSuccessPopup(true);
      setIsPushed(true);
      await dispatch(getProductInfoById(productInfo.id));
    } catch (error) {
      console.error("Push both error:", error);
      showToastMessage("Push failed.");
    } finally {
      dispatch(setLoading({ isLoading: false }));
    }
  };
  const isHexField = (field) =>
  field?.fieldName?.trim().toLowerCase() === "hex input values";

  const handleHexChange = (e) => {
  const { name, value } = e.target;
  const raw = value.replace(/\s/g, '').toUpperCase();
  
  if (!/^[0-9A-F]*$/.test(raw)) {
    setHexError(prev => ({ ...prev, [name]: "Only 0-9 and A-F allowed" }));
    return;
  }
  
  setHexError(prev => ({ ...prev, [name]: "" }));
  const formatted = raw.match(/.{1,2}/g)?.join(' ') || '';
  dispatch(setFormInputValues({ ...formInputs, [name]: formatted }));
}

  return (
    <>
      <div className={styles.sharedDataFormFields}>
        <div>
          <div className={styles.sharedDataFormName}>Shared Data Forms</div>
          <div className={styles.sharedDataFormText}>
            Please fill in the forms to create a shared data file
          </div>
        </div>
      </div>
      {Object.keys(inputFields).length > 0 && (
        <div className={styles.sharedDataFormContainer}>
          <div className={styles.tableContainer}>
            <table className={styles.body}>
              <tbody>
                {valuesArray.map((keysArray) =>
                     keysArray.map((key) => {
                      if (
                        inputFields[key].dataType !== fieldTypeOptions.dropdown
                      ) {
                        return (
                          <tr key={key} className={styles.tr}>
                            <td className={styles.td} style={{width: '100%'}}>
                            <label>{inputFields[key].fieldName}  
                              <span
                                className={styles.tooltip}
                                title={inputFields[key].desc}
                              >
                                <FaInfoCircle />
                              </span></label>
                            {isHexField(inputFields[key]) ? (
                            <>
                            <textarea
                              id={inputFields[key].fieldName}
                              name={inputFields[key].fieldName}
                              className={styles.hexTextArea}
                              style={getStyle(inputFields[key].fieldName)}
                              value={cleanDisplayValue(formInputs[inputFields[key].fieldName])}
                              onChange={handleHexChange}
                              placeholder={`${inputFields[key].placeholderText}${inputFields[key].unit}`}
                              rows={5}
                            />
                                {hexError[inputFields[key].fieldName] && (
                                  <div className={styles.errorText}>{hexError[inputFields[key].fieldName]}</div>
                                )}
                            </>
                            ) : (
                            <input
                              id={inputFields[key].fieldName}
                              style={getStyle(inputFields[key].fieldName)}
                              name={inputFields[key].fieldName}
                              value={cleanDisplayValue(formInputs[inputFields[key].fieldName])}
                              onChange={handleChange}
                              type={
                                inputFields[key].dataType === "string"
                                  ? "text"
                                  : "number"
                              }
                              step={inputFields[key].dataType === 'number' ? "1" : "0.000001"}
                              maxLength={
                                inputFields[key].dataType === "string"
                                ?inputFields[key].noOfBytes:undefined
                              }
                              onKeyDown={(e) => {
                                const dataType = inputFields[key].dataType;
                                // Prevent unwanted characters in numeric fields
                                if ((dataType === "number" || dataType === "float")) {
                                  if (e.key === "+" || e.key === "-" || e.key === "e" || e.key === "E") {
                                    e.preventDefault();
                                  }
                                  // Prevent decimal point for number fields (integer behavior)
                                  if (dataType === "number" && e.key === ".") {
                                    e.preventDefault();
                                  }
                                }
                              }}
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                              placeholder={`${inputFields[key].placeholderText}${inputFields[key].unit}`}
                            />
                            )}
                            {errors[inputFields[key].fieldName] && (
                              <div className={styles.errorText}>
                                {errors[inputFields[key].fieldName]}
                              </div>
                            )}
                            <RenderComments
                              comments={comments}
                              label={inputFields[key].fieldName}
                              onDeleteComment={onDeleteComment}
                              onAddReply={onReplySubmit}
                              onCancel={onCancel}
                            />
                          </td>
                        </tr>
                        );
                      } else if (
                        inputFields[key].dataType === fieldTypeOptions.dropdown
                      ) {
                        return (
                          <tr key={key} className={styles.tr}>
                             <td className={styles.td} style={{width: '100%'}}>
                            <label>{inputFields[key].fieldName}
                              <span
                                className={styles.tooltip}
                                title={inputFields[key].desc}
                              >
                                <FaInfoCircle />
                              </span>
                            </label>
                            <Select
                              id={inputFields[key].fieldName}
                              style={getStyle(inputFields[key].fieldName)}
                              name={inputFields[key].fieldName}
                              placeholder={`${inputFields[key].placeholderText}${inputFields[key].unit}`}
                              value={getOptionLabel(inputFields[key])}
                              onChange={(selectedOption) => {
                                handleSelectChange(
                                  inputFields[key].fieldName,
                                  selectedOption
                                );
                              }}
                              // className={getSelectElClass(inputFields[key].fieldName)}
                              options={getOptions(inputFields[key])}
                              styles={{
                                control: (defaultStyles) => ({
                                  ...defaultStyles,
                                  overflow: "hidden",
                                  fontFamily: "UniversLTStd-Light",
                                  width: "100%",
                                  fontSize: ".82rem",
                                  borderCollapse: "separate",
                                  height: "2.9rem",
                                  outline: "none",
                                  borderRadius: ".5rem",
                                  marginTop: "0.5rem",
                                  marginBottom: "1rem",
                                  textAlign: "left",
                                }),
                                indicatorSeparator: () => ({}),
                              }}
                            />
                            {errors[inputFields[key].fieldName] && (
                              <div className={styles.errorText}>
                                {errors[inputFields[key].fieldName]}
                              </div>
                            )}
                            <RenderComments
                              comments={comments}
                              label={inputFields[key].fieldName}
                              onDeleteComment={onDeleteComment}
                              onAddReply={onReplySubmit}
                              onCancel={onCancel}
                            />
                          </td>
                        </tr>
                        );
                      }
                     return null;
                    }
                ))}
                {(
                  (productInfo?.State === null || productInfo?.State === "Draft") &&
                  (!updateActionItemMode || (updateActionItemMode && actionItem?.State === "Draft")) &&
                  !isPreApproved
                ) ? (
                  <tr>
                    <td className={styles.td}>
                      <label>Reviewer</label>
                      <Select
                        id="reviewer-select-input"
                        name="Reviewer"
                        placeholder="Select reviewer(s)"
                        isMulti
                        onChange={(selectedOptions) => {
                          // selectedOptions is an array of selected reviewer objects
                          const reviewerEmails = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                          dispatch(setFormInputValues({ ...formInputs, Reviewer: reviewerEmails }));
                          setErrors((prevState) => ({
                            ...prevState,
                            Reviewer: "",
                          }));
                        }}
                        value={users.filter(user => Array.isArray(formInputs.Reviewer) ? formInputs.Reviewer.includes(user.value) : false)}
                        options={users}
                        styles={{
                          control: (defaultStyles) => ({
                            ...defaultStyles,
                            overflow: "hidden",
                            fontFamily: "UniversLTStd-Light",
                            width: "100%",
                            fontSize: ".82rem",
                            borderCollapse: "separate",
                            height: "2.9rem",
                            outline: "none",
                            borderRadius: ".5rem",
                            marginTop: "0.5rem",
                            marginBottom: "1rem",
                            textAlign: "left",
                          }),
                          indicatorSeparator: () => ({}),
                        }}
                      />
                      {/* {errors[inputFields[key].fieldName] && (
                      <div className={styles.errorText}>
                        {errors[inputFields[key].fieldName]}
                      </div>
                    )} */}
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </div>
          <div className={styles.bottomContainer}>
            {/* {currentSdState === sdStates.staging && isAdmin(user) && (
              <div className={styles.disclaimerText}>
                <input
                  className={styles.checkbox}
                  type="checkbox"
                  name="confirmTested"
                  onChange={handleCheckbox}
                />
                <span>
                  Confirm that the staging data is tested with the actual
                  devices and is ready to push to production.
                </span>
              </div>
            )} */}
            {/* {currentSdState === sdStates.production && (
              <div className={styles.disclaimerText}>
                * The Production data has to be saved to staging and tested with
                the actual devices to be ready to push to production.
              </div>
            )} */}
            <div className={styles.buttonContainer}>
               {(productInfo?.State === null || productInfo?.State === sdStates.draft) && (
                <Button
                  style={styles.buttons}
                  onClick={async (e) => {
                    e.preventDefault();
                    const { fieldValidation } = validateForm(inputFields, formInputs, sdStates.draft, 0, false);
                    if (Object.keys(fieldValidation).length > 0) {
                      setErrors(fieldValidation);
                      showToastMessage(`Check following fields and fix the error: ${Object.keys(fieldValidation).toString()}.`);
                      return;
                    }
                    // await dispatch(saveAsDraftActionItem());
                    // navigate("/products");
                    await dispatch(saveAsDraftActionItem(() => navigate("/products")));
                  }}
                >
                  <span>Save as Draft</span>
                </Button>
               )}
              {/* {sharedDataModal.isOpen &&
                sharedDataModal.type === sdStates.draft && (
                  <SharedDataPopup
                    onAbort={() => {
                      dismissModal();
                    }}
                    onSuccess={() => {
                      navigate("/products");
                    }}
                    action={action}
                    state="Draft"
                    emailExist={true}
                  />
                )} */}
              {isPreApproved && actionItem?.Status !== "APPROVED" && (
                <Button
                  style={
                    checkIfFormIsFilled()
                      ? styles.longButton
                      : [styles.longButton, styles.buttonDisable]
                  }
                  onClick={
                    checkIfFormIsFilled()
                      ? async (e) => {
                          e.preventDefault();
                          const recipeId = await getRecipeInputIdForApprovedProduct(
                            productInfo?.ModelNumber,
                            productInfo?.State
                          );
                          if (recipeId && productInfo?.ModelNumber) {
                            await updateApprovedProductInputs({
                              recipeId,
                              modelNumber: productInfo.ModelNumber,
                              updatedInputs: formInputs,
                              state: productInfo.State,
                              onSuccess: () => {
                                showToastMessage(
                                  "Recipe input updated successfully."
                                );
                                navigate("/products");
                              },
                              onError: () => {
                                showToastMessage(
                                  "Update failed. Please try again."
                                );
                              },
                            });
                          } else {
                            showToastMessage(
                              "Recipe ID or Model Number not found"
                            );
                          }
                        }
                      : null
                  }
                >
                  <span>Update Approved Product</span>
                </Button>
              )}

              {/* Temporary placeholder for Submit for Approval Button */}
              {updateActionItemMode && actionItem?.Status === "IN_REVIEW" && !(productInfo?.State === sdStates.draft && actionItem?.State === sdStates.draft) ? (
                <Button
                  style={
                    checkIfFormIsFilled() && isFormChanged
                      ? styles.longButton
                      : [styles.longButton, styles.buttonDisable]
                  }
                  onClick={
                    checkIfFormIsFilled() && isFormChanged
                      ? (e) => {
                          e.preventDefault();
                         const validationResponse = validateStagingForm();

                                   if (!validationResponse.stateValidation) {
                                     showToastMessage(
                                       `All field values must be entered before saving to ${sdStates.staging}.`
                                     );
                                     return;
                                   }

                                   if (Object.keys(validationResponse.fieldValidation).length > 0) {
                                     setErrors(validationResponse.fieldValidation);
                                     showToastMessage(
                                       `Fix fields: ${Object.keys(validationResponse.fieldValidation).join(", ")}.`
                                     );
                                     return;
                                   }
                          setPopupConfig({
                            title: <b>Are you sure you want to update this Action Item?</b>,
                            description: "Click 'Yes' to confirm or 'Cancel' to go back.",
                            onSuccess: async () => {
                              setPopupConfig(null);
                              await updateActionItemData();
                            },
                            onCancel: () => setPopupConfig(null),
                          });
                        }
                      : null
                  }
                >
                  <span>Update Action Item</span>
                </Button>
              ) : !actionItem?.id || (productInfo?.State === null) || (productInfo?.State === sdStates.draft ) ? (
                <Button
                  style={
                    checkIfFormIsFilled()
                      ? styles.longButton
                      : [styles.longButton, styles.buttonDisable]
                  }
                  onClick={
                    checkIfFormIsFilled()
                      ? (e) => {
                          e.preventDefault();
                          saveToState(sdStates.staging, action);
                        }
                      : null
                  }
                >
                  <span>Submit for CoolCloud Test</span>
                </Button>
              ) : null}

              {updateActionItemMode && productInfo?.State === sdStates.staging && (
                <Button
                  style={
                    checkIfFormIsFilled() && isFormChanged
                      ? styles.longButton
                      : [styles.longButton, styles.buttonDisable]
                  }
                  onClick={
                    checkIfFormIsFilled() && isFormChanged
                      ? (e) => {
                          e.preventDefault();

                          const validationResponse = validateStagingForm();
                          if (!validationResponse.stateValidation) {
                            showToastMessage(
                              `All field values must be entered before saving to ${sdStates.staging}.`
                            );
                            return;
                          }
                          if (Object.keys(validationResponse.fieldValidation).length > 0) {
                            setErrors(validationResponse.fieldValidation);
                            showToastMessage(
                              `Check following fields and fix the error: ${Object.keys(validationResponse.fieldValidation).join(", ")}.`
                            );
                            return;
                          }
                         setPopupConfig({
                           title: <b>Are you sure you want to update data in CoolCloud?</b>,
                           description: "Click 'Yes' to confirm or 'Cancel' to go back.",
                           onSuccess: async () => {
                             setPopupConfig(null);

                          try {
                            dispatch(setLoading({ isLoading: true }));
                            const userInput = formInputs;

                            // Step 1: Update the actionItem table with new inputs (no state change)
                            const actionItemPayload = {
                              input: {
                                id: actionItem.id,
                                Input: JSON.stringify(userInput),
                                State: sdStates.staging,
                              },
                            };
                            await sharedDataApi.updateActionItems(actionItemPayload);

                            // Step 2: Update the recipeInput table with new inputs (no state change)
                            const recipeId = actionItem.id;
                            if (recipeId) {
                              const recipePayload = {
                                input: {
                                  id: recipeId,
                                  ModelNumber: actionItem.ModelNumber,
                                  Input: JSON.stringify(userInput),
                                  State: sdStates.staging,
                                },
                              };
                              await sharedDataApi.updateSdUserInputs(recipePayload);
                            }

                            // Step 3: Update the product state back to Staging
                            await productApi.updateProductData({
                              input: {
                                id: actionItem.ProductId,
                                ModelNumber: actionItem.ModelNumber,
                                State: sdStates.staging,
                                CoolCloudDBAck: false,
                              },
                            });
                            const result = await executeCoolCloudOperations(
                              actionItem,
                              productInfo,
                              recipeData,
                              userInput
                            );

                            if (result && result.error) {
                              setPopupConfig({
                                title: <b>CoolCloud data push failed. Records were updated but CoolCloud sync failed. Please try again.</b>,
                                successText: "OK",
                                cancelText: null,
                                onSuccess: () => setPopupConfig(null),
                              });
                            } else {
                              setPopupConfig({
                                title: <>Records updated and data successfully sent to CoolCloud.</>,
                                successText: "OK",
                                cancelText: null,
                                onSuccess: () => {
                                  setPopupConfig(null);
                                  navigate("/dashboard?tab=incoolcloudtest");
                                },
                              });
                            }
                          } catch (err) {
                            console.error("Re-edit CoolCloud error:", err);
                            setPopupConfig({
                              title: <b>Update failed. Please try again.</b>,
                              successText: "OK",
                              cancelText: null,
                              onSuccess: () => setPopupConfig(null),
                            });
                          } finally {
                            dispatch(setLoading({ isLoading: false }));
                          }
                          },
                          onCancel: () => setPopupConfig(null),
                        });

                        }
                      : null
                  }
                >
                  <span>Update CoolCloud</span>
                </Button>
              )}
              {updateActionItemMode &&
                 productInfo?.State === sdStates.production &&
                 isAdmin(currentUser) && (
                   <>
                     {/* Push to CoolCloud Production and AMS Production button */}
                    <Button
                       style={
                         !isPushed && isFormChanged
                           ? styles.longButton
                           : [styles.longButton, styles.buttonDisable]
                       }
                       disabled={isPushed || !isFormChanged}
                       onClick={!isPushed && isFormChanged ? confirmPushToProduction : null}
                     >
                       <span>Update CoolCloud and AMS Production</span>
                     </Button>
                   </>
               )}

              {sharedDataModal.isOpen &&
                sharedDataModal.type === sdStates.staging && (
                  <SharedDataPopup
                    onAbort={() => {
                      dismissModal();
                      navigate(`/products`);
                    }}
                    state="Staging"
                    action={action}
                    onSuccess={() => {
                      navigate("/products");
                    }}
                    // revisionNumbers={
                    //   sharedDataModal.revisionNumber.length > 0
                    //     ? sharedDataModal.revisionNumber
                    //     : []
                    // }
                  />
                )}

              {sharedDataModal.isOpen &&
                sharedDataModal.type === sdStates.production && (
                  <SharedDataPopup
                    onAbort={() => {
                      dismissModal();
                    }}
                    state="Production"
                    action={action}
                    onSuccess={() => {
                      navigate("/products");
                    }}
                    // revisionNumbers={
                    //   sharedDataModal.revisionNumber.length > 0
                    //     ? sharedDataModal.revisionNumber
                    //     : []
                    // }
                  />
                )}
            </div>
          </div>
        </div>
      )}
      {showPopup && (
        <Popup
          title={
            <>
              Your <span className={styles.bold}>edits will be discarded</span>{" "}
              if you change the state. Are you sure you want to continue ?
            </>
          }
          description="Click 'Yes' to confirm or 'Cancel' to go back."
          onSuccess={() => {
            setShowPopup(false);
            setCurrentRadioOption(selectedRadioOption);
            setSdState(selectedRadioOption);
          }}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
      {popupConfig && (
        <Popup
          title={popupConfig.title}
          description={popupConfig.description || null}
          successText={popupConfig.successText || "Yes"}
          cancelText={popupConfig.cancelText !== undefined ? popupConfig.cancelText : "Cancel"}
          warningMessage={popupConfig.warningMessage || null}
          onSuccess={popupConfig.onSuccess}
          onCancel={popupConfig.onCancel}
        />
      )}
      {showPopup && (
        <Popup
          title={<b>{popupText}</b>}
          description="Click 'Yes' to confirm or 'Cancel' to go back."
          onSuccess={async () => {
      if (popupAction === "bothProduction") {
        await handlePushToBothProduction();
      }

      setShowPopup(false);
      setPopupAction(null);
    }}
    onCancel={() => {
      setShowPopup(false);
      setPopupAction(null);
    }}
  />
)}
      {successPopup && (
        <Popup
          title={<span>CoolCloud and AMS data successfully pushed.</span>}
          successText="OK"
          cancelText={null}
          onSuccess={() => {
            setSuccessPopup(false);
            navigate("/products");
          }}
        />
      )}
     </>
  );
};

export default SharedDataForm;
